import { render, staticRenderFns } from "./good.vue?vue&type=template&id=1e4e5ed1&scoped=true&"
import script from "./good.vue?vue&type=script&lang=js&"
export * from "./good.vue?vue&type=script&lang=js&"
import style0 from "./good.vue?vue&type=style&index=0&id=1e4e5ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e5ed1",
  null
  
)

export default component.exports